import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './InfoPages.css';

const faqItems = [
  {
    category: 'Buying Equipment',
    questions: [
      {
        q: 'What is the difference between ClubLoop Stock and a Golfer Listing?',
        a: 'ClubLoop Stock items (Green Badge) are owned, physically inspected, graded, and shipped directly by ClubLoop. Golfer Listings (Blue Badge) are peer-to-peer offers listed directly by individual golfers, where ClubLoop secures the payment in escrow to protect both parties.',
      },
      {
        q: 'How does the ClubLoop Payment Protection escrow work?',
        a: 'When you buy a peer-to-peer Golfer Listing, your payment is held safely by ClubLoop. The funds are only released to the seller after you receive the club and confirm its condition, or after 5 days in transit if no dispute is raised.',
      },
      {
        q: 'How can I trust the condition of the clubs?',
        a: 'Every listing features a mandatory premium quality grade tag ranging from A+ (Unused/Mint) down to C (Fair/Functional). This ensures absolute transparency so you know exactly how the club plays before placing your order.',
      },
    ],
  },
  {
    category: 'Selling Your Clubs',
    questions: [
      {
        q: 'How do I list my golf equipment for sale?',
        a: 'Click "Sell Your Clubs" in the nav header, fill out our mobile-optimized submission form (brand, model, hand, specs), select one of the 4 visual condition tiles, upload your photos, and set your asking price in Rupees.',
      },
      {
        q: 'What are the fees for selling on the P2P marketplace?',
        a: 'Listing your gear is completely free. ClubLoop only collects a flat 10% commission fee from the total value once your club successfully sells and delivery is fully confirmed by the buyer.',
      },
      {
        q: 'When and how do I receive my payout?',
        a: 'Once the buyer confirms receipt of the club or the 5-day automated approval window passes, ClubLoop transfers your earnings directly to your registered UPI ID or Bank account within 1 business day.',
      },
    ],
  },
  {
    category: 'Shipping & Returns',
    questions: [
      {
        q: 'Who handles the shipping for marketplace orders?',
        a: 'For Golfer Listings, sellers are expected to securely package and ship the club via local courier tracking links within 48 hours of a confirmed purchase. ClubLoop Stock items are packaged and delivered directly via our primary courier network.',
      },
      {
        q: 'What happens if there is a dispute with my delivered item?',
        a: 'If a club arrives damaged or does not match the assigned condition grade tag, buyers can raise an official dispute within 5 days of delivery by contacting support to freeze the transaction escrow while our admin team mediates.',
      },
    ],
  },
];

function HelpCenter() {
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  let id = 0;
  return (
    <div className="infoPage">
      <Header />
      <div className="infoPageLayout">
        <div className="infoHero">
          <h1>ClubLoop Help Centre</h1>
          <p>
            Find comprehensive guides and instant answers regarding our golf equipment grading frameworks,
            protected payments, and peer-to-peer marketplace systems.
          </p>
        </div>

        <div className="infoSection">
          <h2>Search & Browse Tips</h2>
          <p>
            Use our homepage search utility to lookup key golf assets by specific brand, category, or profile layout.
            You can instantly narrow your scope using our target filters for Men's, Women's, or Junior category setups,
            as well as condition grades and pricing thresholds.
          </p>
        </div>

        <div className="infoSection">
          <h2>Frequently Asked Questions</h2>
          {faqItems.map(({ category, questions }) => (
            <div key={category} style={{ marginBottom: '24px' }}>
              <h3 style={{ color: '#0F4424', marginBottom: '12px' }}>{category}</h3>
              {questions.map(({ q, a }) => {
                const currentId = ++id;
                const isOpen = openId === currentId;
                return (
                  <div key={currentId} style={{ marginBottom: '8px' }}>
                    <button
                      type="button"
                      className="infoAccordionHeader"
                      onClick={() => toggle(currentId)}
                      aria-expanded={isOpen}
                      style={{ textAlign: 'left', width: '100%' }}
                    >
                      {q}
                    </button>
                    {isOpen && (
                      <div className="infoAccordionContent">
                        <p style={{ margin: 0, color: '#555', lineHeight: '1.6' }}>{a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <div className="infoSection">
          <h2>Still Need Help?</h2>
          <p>
            If your transaction question or gear scenario wasn't covered in our documentation framework, please{' '}
            <Link to="/contact" className="infoLink">
              contact our support desk
            </Link>{' '}
            and our golf team will look into your request as soon as possible.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HelpCenter;
